import api from '../../lib/api';

export type QboAccountingOption = { id: string; name: string };
export type QboAccountingCatalog = {
  realmId: string;
  classEnabled: boolean;
  locationEnabled: boolean;
  classes: QboAccountingOption[];
  locations: QboAccountingOption[];
};
export async function getInvoiceAccountingCatalog(): Promise<QboAccountingCatalog> {
  const { data } = await api.get<QboAccountingCatalog>('/organization/orders/invoice-accounting');
  return data;
}
